import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { LoomPreviewPanelProps } from './ui/types';

export const loomPreviewPanelEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		LoomPreviewPanelProps,
		Record<string, never>
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "loom-preview-panel-entrypoint" */ './ui/loom-preview-panel/main'
			),
		{
			moduleId: 'loom-preview-panel-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});
